"use client";

import { useEffect } from "react";

const EDITABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return EDITABLE_TAGS.has(target.tagName) || target.isContentEditable;
}

/**
 * Site-weiter Tastatur-Shortcut "/" fokussiert die Suche (backlog.md ->
 * Aktienfinder-Benchmark, "Site-weite Tastatur-Shortcuts für Power-User") - mountet
 * einmal global (siehe app/layout.tsx, gleiches Muster wie BackToTopButton), rendert
 * selbst nichts. Zielt per `[data-search-input="true"]` auf das erste sichtbare
 * SearchHero-Eingabefeld statt eine eigene Ref/Prop quer durch die Komponente zu
 * ziehen. **2026-08-19 von `id="site-search-input"` auf dieses Daten-Attribut
 * umgestellt** (Bug-Fix, volle Herleitung in app/[symbol]/layout.tsx): SearchHero
 * nutzt jetzt `useId()` für sein eigentliches `id` (muss laut HTML-Spezifikation
 * eindeutig sein, sobald mehr als eine Instanz gleichzeitig sichtbar ist, z. B.
 * Header-Suche + Startseiten-Hero-Suche fuer eingeloggte Pro/Max-Nutzer, siehe
 * app/page.tsx) - ein `data-*`-Attribut braucht dagegen keine Eindeutigkeit,
 * `querySelector` liefert einfach die erste (oberste) Instanz. Feuert nicht,
 * während bereits in einem anderen Eingabefeld getippt wird (sonst würde z.B. ein
 * "/" in einem Kommentartext ungewollt den Fokus wegreißen), und nicht bei
 * gedrückten Modifier-Tasten (Cmd+/, Strg+/ etc. haben oft eine eigene
 * Browser-/OS-Bedeutung).
 */
export function SearchKeyboardShortcut() {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey) return;
      if (isTypingTarget(e.target)) return;
      const input = document.querySelector<HTMLInputElement>('[data-search-input="true"]');
      if (!input) return;
      e.preventDefault();
      input.focus();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return null;
}
